export enum Onboarding {
  SHOW_INTRO = 'SHOW_INTRO',
  HIDE_INTRO = 'HIDE_INTRO',
}

export interface ISettings {
  reminderInterval: number[];
  onboarding: Onboarding;
}
